__webpack_require__.p = "https://calendario.tec.mx/sedes/";